import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import './CommentHistoryTable.css';

class CommentHistoryTable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            addingEntry: false,
            editingIndex: null,
        };
    }

    handleEditChange = (index, value) => {
        if (this.props.handleCommentEdit) this.props.handleCommentEdit(index, value);
    }

    handleDelete = (index) => {
        if (this.props.handleCommentDelete) this.props.handleCommentDelete(index);
    }

    render() {
        const isEditable = this.props.type === "todo"; // only editable for salesPipeline

        return (
            <div className='comments-container'>
                <Typography variant='h5' className="comments-title">Comments</Typography>
                <Table className='comment-table'>
                    <TableHead>
                        <TableRow>
                            <TableCell className='date-user-heading-cell' />
                            <TableCell className='comment-heading-cell' />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.comments.map((entry, index) => (
                            <TableRow key={index} className="comment-row">
                                <TableCell className='comment-right-border no-text-wrap no-bottom-border'>
                                    <div className="date-user-cell">
                                        {entry.date.split('T')[0]} <br />{" (" + entry.user + ")"}
                                    </div>
                                </TableCell>
                                <TableCell className={(index + 1 === this.props.comments.length && this.props.disabled)
                                    ? 'comment-right-border comment-bottom-border'
                                    : 'comment-right-border'}>
                                    {this.state.editingIndex === index ? (
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            multiline
                                            value={entry.comment}
                                            onChange={(e) => this.handleEditChange(index, e.target.value)}
                                            onBlur={() => this.setState({ editingIndex: null })}
                                        />
                                    ) : (
                                        <span>{entry.comment}</span>
                                    )}

                                    {isEditable && (
                                        <div className='comment-actions'>
                                            <IconButton size="small" onClick={() => this.setState({ editingIndex: index })}>
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton size="small" onClick={() => this.handleDelete(index)}>
                                                <RemoveCircleIcon fontSize="small" color="error" />
                                            </IconButton>
                                        </div>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}

                        {!this.props.disabled && isEditable && !this.state.addingEntry && (
                            <TableRow>
                                <TableCell className='comment-right-border no-bottom-border'>
                                    <div className='add-delete-cell'>
                                        <IconButton onClick={() => this.setState({ addingEntry: true })}>
                                            <AddCircleIcon fontSize="small" color='secondary' />
                                        </IconButton>
                                    </div>
                                </TableCell>
                                <TableCell className='comment-right-border comment-bottom-border' />
                            </TableRow>
                        )}

                        {!this.props.disabled && isEditable && this.state.addingEntry && (
                            <TableRow>
                                <TableCell className='comment-right-border no-bottom-border'>
                                    <div className='add-delete-cell'>
                                        <IconButton onClick={() => this.setState({ addingEntry: false })}>
                                            <RemoveCircleIcon fontSize="small" color="error" />
                                        </IconButton>
                                    </div>
                                </TableCell>
                                <TableCell className='comment-right-border comment-bottom-border'>
                                    <div className='add-comment-row'>
                                        <TextField
                                            className='comments-field'
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            value={this.props.newComment || ''}
                                            onChange={(e) => this.props.handleCommentUpdate(e.target.value)}
                                            label="Enter your comment"
                                        />
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                if (!this.props.newComment?.trim()) return;
                                                const newCommentObj = {
                                                    user: `${this.props.currentUser.firstname} ${this.props.currentUser.lastname}`,
                                                    date: new Date().toISOString(),
                                                    comment: this.props.newComment
                                                };
                                                this.props.handleCommentUpdate([...this.props.comments, newCommentObj], true);
                                            }}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}

                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default CommentHistoryTable;
